import useLocation from '@/ui/hooks/use-location';
import type { SwapPageLocationState } from '../types.js';

const useLocationState = () => {
  const location = useLocation<SwapPageLocationState>();
  const { token, referrer = 'unknown' } = location.state ?? {};
  return { token, referrer };
};

export default useLocationState;
